import { Box, styled, } from '@mui/system';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton, Typography, Slide } from '@mui/material';
import React, { FC } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { TransitionProps } from '@mui/material/transitions';
import { CheckCircleOutline, WarningSharp } from '@mui/icons-material';
export const ConfirmationDialogTl = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    '& strong': {
        color: theme.palette.primary.main,
        fontWeight: 700,
    },
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export interface AppConfirmationModalProps
    extends Pick<DialogProps, 'open' | 'onClose'> {
    onSuccess: () => void;
    onFail: () => void;
    message: React.ReactNode;
    type?: "warning" | "success" | "delete";
}

const AppConfirmationModal: FC<AppConfirmationModalProps> = ({ open, onClose, onSuccess, onFail, message, type = "delete" }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            slotProps={{
                transition: Transition
            }}
            keepMounted
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xs"
        >

            <IconButton
                aria-label="close"
                onClick={onFail}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ pt: 6, px: 4 }}>

                <Box sx={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: type === "warning" ? "#FFC10721" : type === "success" ? "#4CAF5021" : "#ff4c4c21",
                    color: type === "warning" ? "#FFC107" : type === "success" ? "#4CAF50" : "#F44336",
                    textAlign: "center",
                    placeContent: "center",
                    placeItems: "center",
                    mx: "auto",
                    mb: 2
                }}>
                    {type === "warning" ? <WarningSharp /> : type === "success" ? <CheckCircleOutline /> : <DeleteIcon />}
                </Box>

                <ConfirmationDialogTl variant="h4" fontWeight={"400"} lineHeight={"1.45"}> {message} </ConfirmationDialogTl>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pt: 1, pb: 4, px: 4 }}>
                <Button disableElevation variant="contained" color="error" onClick={onSuccess}>YES</Button>
                <Button disableElevation variant="outlined" color="error" onClick={onFail}>NO</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AppConfirmationModal